import React from 'react'

export function LoaderSvg() {
  return (
    <svg className="loader" viewBox="25 25 50 50">
      <circle
        className="loader__path"
        cx="50"
        cy="50"
        r="20"
        fill="none"
        strokeWidth="3"
        strokeMiterlimit="10"
      />
    </svg>
  )
}
